(() => {
  // 設定変数
  const REVIEW_PRIVACY_CONFIG = {
    judgemeTermsUrl: 'https://judge.me/terms',
    judgemeTermsText: '利用規約',
    judgemePrivacyUrl: 'https://judge.me/privacy',
    judgemePrivacyText: 'プライバシーポリシー',
    judgemeContentPolicyUrl: 'https://judge.me/content-policy',
    judgemeContentPolicyText: 'コンテンツポリシー',
    cohinaTermsUrl: 'https://cohina.net/policies/terms-of-service',
    cohinaTermsText: '利用規約',
    cohinaPrivacyUrl: 'https://cohina.net/pages/privacy-policy',
    cohinaPrivacyText: 'PRIVACY POLICY'
  };

  // プライバシーポリシーpタグ検出関数
  const findPrivacyParagraph = (form) => {
    if (!form) return null;

    const paragraphs = Array.from(form.querySelectorAll('.jdgm-form__fieldset p'));

    // メイン判定: Judge.meリンク + テキスト内容
    let target = paragraphs.find(p => {
      const hasJudgemeLink = p.querySelector('a[href*="judge.me"]');
      const hasPrivacyText = p.textContent.includes('レビューを送信') || p.textContent.includes('同意');
      return hasJudgemeLink && hasPrivacyText;
    });

    // フォールバック: Judge.meリンクのみ
    if (!target) {
      target = paragraphs.find(p => p.querySelector('a[href*="judge.me"]'));
    }

    return target;
  };

  // HTML生成関数
  const generatePrivacyHtml = (config) => {
    return `レビューを送信することで、Judge.meの<a href="${config.judgemeTermsUrl}" target="_blank" rel="nofollow noopener" style="text-decoration: underline;">${config.judgemeTermsText}</a>・<a href="${config.judgemePrivacyUrl}" target="_blank" rel="nofollow noopener" style="text-decoration: underline;">${config.judgemePrivacyText}</a>・<a href="${config.judgemeContentPolicyUrl}" target="_blank" rel="nofollow noopener" style="text-decoration: underline;">${config.judgemeContentPolicyText}</a>、および弊社の<a href="${config.cohinaTermsUrl}" target="_blank" rel="noopener" style="text-decoration: underline;">${config.cohinaTermsText}</a>・<a href="${config.cohinaPrivacyUrl}" target="_blank" rel="noopener" style="text-decoration: underline;">${config.cohinaPrivacyText}</a>に同意いただいたものといたします。`;
  };

  // プライバシーポリシー更新関数
  const updatePrivacyPolicy = (form) => {
    if (!form) return;

    const privacyParagraph = findPrivacyParagraph(form);

    if (!privacyParagraph) {
      console.warn('[COHINA] レビューフォームのプライバシーポリシー要素が見つかりませんでした');
      return;
    }

    const newHtml = generatePrivacyHtml(REVIEW_PRIVACY_CONFIG);
    privacyParagraph.innerHTML = newHtml;
  };

  // フォーム検出と処理
  const processReviewForms = () => {
    const forms = document.querySelectorAll('.jdgm-form');

    if (!forms.length) return;

    forms.forEach(form => {
      updatePrivacyPolicy(form);
    });
  };

  // レビューを書くリンクのクリックイベント監視
  const initWriteReviewLinks = () => {
    const writeReviewLinks = document.querySelectorAll('.jdgm-write-rev-link');

    writeReviewLinks.forEach(link => {
      link.addEventListener('click', () => {
        // クリック後、少し待ってからフォームをチェック
        setTimeout(() => {
          processReviewForms();
        }, 300);
      });
    });
  };

  // 初期化処理
  const init = () => {
    initWriteReviewLinks();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
